import fileBrowser from '@/api/file-manager/file-browser'

export const state = {
  currentFolder: undefined,
  currentFolderId: undefined,
  navigation: undefined,
  createNewFolderStatus: undefined,
  entries: [],
  direction: 'ASC',
  folders: [],
  files: []
}

export const actions = {
  getFolder(context, id, attrubutes = {}) {
    context.commit('LOADING_STATE', { loading: true, data: [] })
    let params = Object.assign(
      {
        sort: 'updated_at',
        direction: context.state.direction
      },
      attrubutes
    )
    return fileBrowser.getFolder(id, { params }).then(response => {
      let folders = response.folders.data
      let files = response.files.data

      context.commit('SET_FOLDERS', folders)
      context.commit('SET_FILES', files)

      context.commit('LOADING_STATE', {
        loading: false,
        data: folders.concat(files)
      })
      context.commit('SET_CURRENT_FOLDER', response.root)
    })
  },
  getBrowseSearch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        filter: 'undefined'
      },
      attrubutes
    )
    return fileBrowser.getBrowseSearch({ params }).then(response => {
      let folders = response.folders.data
      let files = response.files.data

      context.commit('SET_FOLDERS', folders)
      context.commit('SET_FILES', files)
    })
  },
  getFolderTree(context, attrubutes = {}) {
    let params = Object.assign(
      {
        sort: 'created_at',
        direction: 'DESC'
      },
      attrubutes
    )
    return fileBrowser.getFolderTree({ params }).then(response => {
      context.commit('UPDATE_FOLDER_TREE', response.data)
      return Promise.resolve(response)
    })
  }
}

export const mutations = {
  LOADING_STATE(state, payload) {
    state.entries = payload.data
    state.isLoading = payload.loading
  },
  SET_FOLDERS(state, folder) {
    state.folders = folder
  },
  SET_FILES(state, file) {
    state.files = file
  },
  SET_CURRENT_FOLDER(state, folder) {
    state.currentFolder = folder
  },
  UPDATE_FOLDER_TREE(state, tree) {
    state.navigation = tree
  },
  SET_CURRENT_FOLDER_ID(state, id) {
    state.currentFolderId = id
  },
  CREATE_NEW_FOLDER_STATUS(state, data) {
    state.createNewFolderStatus = data
  },
  SET_DIRECTION(state, data) {
    state.direction = data
  }
}

export const getters = {
  currentFolder: state => state.currentFolder,
  navigation: state => state.navigation,
  entries: state => state.entries
}
